import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dbt-members',
  templateUrl: './dbt-members.component.html',
  styleUrls: ['./dbt-members.component.scss']
})
export class DBTMembersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
